/** @jsx jsx */
import { any, bool } from 'prop-types'
import { useContext, useEffect } from 'react'
import { Flex, jsx } from 'theme-ui'
import { MaintenancePackageContext } from '../../../../context/MaintenancePackageContext'
import UploadQuestion from '../../../support-package/UploadQuestion'
import { RadioButtonGroupItem } from '../../FormInputs/index'

const RadioInput = ({
  values,
  question,
  option,
  hideLabel = false,
  centerRadio,
  ...props
}) => {
  const { setHasFileToUpload } = useContext(MaintenancePackageContext)
  /* based on question's selection decide to hide/show upload dropzone */
  const showFile =
    (option?.id == 247 || option?.id == 311 || option?.id == 313) &&
    (values[67] == 247 || values[92] == 311 || values[93] == 313)

  useEffect(() => {
    if (option?.id == 247 || option?.id == 311 || option?.id == 313) {
      setHasFileToUpload(showFile)
    }
  }, [showFile])
  return (
    <Flex
      className="radio-container"
      sx={{ flexDirection: 'column' }}
      {...props}
    >
      <RadioButtonGroupItem
        centerRadio={centerRadio}
        value={option.id.toString()}
        label={!hideLabel ? option.text : ''}
        selectedValue={
          Array.isArray(values[question?.id])
            ? values?.[question?.id]?.[0]
            : values?.[question?.id]
        }
        groupId={question.id.toString()}
        className="radio-input"
      />
      {showFile && <UploadQuestion />}
    </Flex>
  )
}

RadioInput.propTypes = {
  values: any,
  question: any,
  option: any,
  hideLabel: bool,
  centerRadio: bool,
}

export default RadioInput
